<div class="conten">
    <div class="logo">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg" alt="Triidy">
        <span class="log-name">Triidy</span>
    </div>
    <div class="spinn" *ngIf="muestraSpinner">
        <mat-spinner></mat-spinner>
        <p>¡Obteniendo transacción!</p>
    </div>
    <h3 *ngIf="muestraError">¡Error en referencia!</h3>
    <h3 *ngIf="muestraResultado">¡Gracias por tu compra!</h3>
    <div class="result" *ngIf="muestraResultado">
        <h4>Resultado de la transacción</h4>
        <div class="cont-result">
            <div class="izq">
                <h6>Referencia</h6>
                <p>{{ detailStatus?.referencia }}</p>
                <h6>Detalle del pedido</h6>
                <p>{{ detailStatus?.detalle }}</p>
                <h6>Fecha y hora</h6>
                <p>{{ detailStatus?.fecha }}</p>
            </div>
            <div class="der">
                <h6>Estado de Transacción</h6>
                <p class="aprob" *ngIf="detailStatus?.status === 'APPROVED'">APROBADA</p>
                <p class="rejec" *ngIf="detailStatus?.status === 'REJECTED'">RECHAZADA</p>
                <p class="pend" *ngIf="detailStatus?.status === 'PENDING'">PENDIENTE</p>
                <h6>Valor total</h6>
                <p>{{ detailStatus?.total | currency:'COP':'symbol':'.0'}}</p>
                <h6>Metodo de pago</h6>
                <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/pse_modal.png" alt="Triidy">
            </div>
        </div>
        <!-- <a class="btn" href="/">Finalizar</a> -->
        <p>Pago presentado por:
            <a href="https://www.placetopay.com/web/" target="_blank"><img src="https://static.placetopay.com/placetopay-logo.svg" class="attachment-0x0 size-0x0" alt="" loading="lazy"></a>
        </p>
        <a routerLink="/faq" target="_blank" class="faq">Preguntas Frecuentes</a>
    </div>
</div>